// key table values for patent status values
export const PATENT_STATES = 'patent';
// patent state for type datainput
export const PATENT_STATE_DATAINPUT = 1;
// patent state for type registred
export const PATENT_STATE_REGISTERED = 2;
// patent state for type published
export const PATENT_STATE_PUBLISHED = 3;
// patent state for type granted
export const PATENT_STATE_GRANTED = 4;

//Key table values for paten registration type
export const PATEN_REGISTRATIONTYPE ='PatentRegistrationType';
export const PATEN_REGISTRATIONTYPE_COUNTRY_SPECIFIC =6;
